export const TENSION_LEVELS = {
  vigilance: { label: 'Vigilance', pill: 'bg-yellow-100 text-yellow-800 border-yellow-300', row: 'bg-yellow-50 dark:bg-yellow-900/20', dot: 'bg-yellow-400' },
  tension: { label: 'Tension', pill: 'bg-orange-100 text-orange-800 border-orange-300', row: 'bg-orange-50 dark:bg-orange-900/20', dot: 'bg-orange-500' },
  critique: { label: 'Critique', pill: 'bg-red-100 text-red-700 border-red-300', row: 'bg-red-50 dark:bg-red-900/20', dot: 'bg-red-600' },
};
export const fmtDateFr = (d) => (d ? new Date(d).toLocaleDateString('fr-FR') : '—');
export const plusOneMonth = () => {
  const d = new Date();
  const day = d.getDate();
  d.setDate(1); d.setMonth(d.getMonth() + 1);
  d.setDate(Math.min(day, new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate()));
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};
export const isOverdue = (d) => d && d < new Date().toISOString().slice(0, 10);
